const radii = {
  none: "0",
  md: "8px",
  lg: "16px",
  xl: "20px",
  full: "9999px",
  intermediate: "12px",
  smIntermediate: "10px",
};

export default radii;
